var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightingColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Lighting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 190,
    height: 150
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693114%",
    x2: "99.999575%",
    y2: "27.7870935%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.1096191,4.48608393 C75.8480225,1.17132562 85.1519775,1.17129511 90.8903809,4.48605341 L156.696167,42.4981079 C159.785645,44.2827148 161.211792,46.6642761 160.974609,48.9999999 L161,48.9999999 L161,83.9999999 L160.974609,83.9999999 C160.77124,86.002716 159.345093,87.9717407 156.696167,89.501892 L90.8903809,127.513946 C85.1519775,130.828705 75.8480225,130.828705 70.1096191,127.513946 L4.30383301,89.501892 C1.65490723,87.9717407 0.228759766,86.002716 0.025390625,83.9999999 L1.8189894e-12,83.9999999 L1.8189894e-12,48.9999999 L0.025390625,48.9999999 C-0.211791992,46.6642761 1.21435547,44.2827148 4.30383301,42.4981079 L70.1096191,4.48608393 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8133345%",
    x2: "93.8547498%",
    y2: "50.7911126%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.2566452,1.61658984 C83.525316,-0.538774192 77.4750011,-0.538952529 73.7433624,1.61659032 L2.79861331,42.5970954 C-0.93302536,44.7526383 -0.93271637,48.2475442 2.79861283,50.4029083 L73.7433548,91.3834152 C77.474684,93.5387792 83.5249989,93.538958 87.2566376,91.3834152 L158.201385,50.4029006 C161.933024,48.2473578 161.932715,44.7524557 158.201385,42.5970916 L87.2566452,1.61658984 Z M103.24913,28.7264022 L63.5052986,36.3411102 C60.8542318,36.8491026 60.0575902,38.7919173 62.0329514,39.9329643 L68.82341,43.8554038 C69.4510717,44.2179662 69.2433271,44.8325019 68.4255524,45.0323638 L29.6260986,54.5027542 C28.3146898,54.8229144 28.7994589,55.9578873 30.218399,55.8891029 L103.488724,52.3313102 C105.611619,52.2284611 106.554871,50.738371 105.048813,49.868412 L95.6842041,44.4590377 C94.9856108,44.0555025 95.3327357,43.3661728 96.2963943,43.2421226 L120.020935,40.1860656 C123.874333,39.6896266 125.262037,36.9318185 122.470139,35.319107 L113.479973,30.1260318 C110.801895,28.5790674 106.843236,28.0376646 103.24913,28.7264022 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-symbols",
    transform: "translate(-2486.000000, -1033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Lighting",
    transform: "translate(2486.000000, 1033.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-116",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1096191,12.4860839 C75.8480225,9.17132562 85.1519775,9.17129511 90.8903809,12.4860534 L156.696167,50.4981079 C159.785645,52.2827148 161.211792,54.6642761 160.974609,56.9999999 L161,56.9999999 L161,91.9999999 L160.974609,91.9999999 C160.77124,94.002716 159.345093,95.9717407 156.696167,97.501892 L90.8903809,135.513946 C85.1519775,138.828705 75.8480225,138.828705 70.1096191,135.513946 L4.30383301,97.501892 C1.65490723,95.9717407 0.228759766,94.002716 0.025390625,91.9999999 L0,91.9999999 L0,56.9999999 L0.025390625,56.9999999 C-0.211791992,54.6642761 1.21435547,52.2827148 4.30383301,50.4981079 L70.1096191,12.4860839 Z",
    id: "Glow",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    opacity: 0.899999976,
    filter: "url(#filter-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.32049,4.37926263 C75.6668728,1.2070753 84.3350804,1.20707506 89.6814631,4.37926215 L150.991185,40.7563667 C156.337569,43.9285547 156.337569,49.0716857 150.991185,52.2438735 L89.6814567,88.6209793 C84.3350783,91.7931642 75.6668744,91.7931749 70.32049,88.6209869 L9.01076412,52.2438774 C3.66438098,49.07169 3.66438018,43.9285552 9.01076452,40.7563667 L70.32049,4.37926263 Z",
    id: "Subtract",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector-66",
    fill: "#9768A6",
    fillRule: "nonzero",
    points: "69.1630859 44.3114623 69.1630859 61.3847045 27.8041938 57.8086163 25.8779297 51.1176629"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector-67",
    fill: "#9768A6",
    fillRule: "nonzero",
    points: "138.432167 37.9633788 138.432167 55.036621 95.322166 55.2293319 95.3222656 43.8944969"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingColor);
export default __webpack_public_path__ + "static/media/LightingColor.6cf379308bf6a955b265c4c069f390e5.svg";
export { ForwardRef as ReactComponent };